export function Kpi({ label, value, tint, testid }) {
  return (
    <div
      className="bg-white border border-slate-200 rounded-lg shadow-sm p-6 flex flex-col gap-2"
      data-testid={testid}
    >
      <span className="text-xs uppercase tracking-[0.2em] text-slate-500">{label}</span>
      <span className={`text-3xl font-bold ${tint || "text-[#0D1B2A]"}`}>{value}</span>
    </div>
  );
}

export function MiniKpi({ label, value, tint }) {
  return (
    <div className="bg-slate-50 rounded p-3">
      <p className="text-[10px] uppercase tracking-widest text-slate-500">{label}</p>
      <p className={`text-xl font-bold ${tint || "text-[#0D1B2A]"}`}>{value}</p>
    </div>
  );
}

export function AuditBadge({ type }) {
  const isCert = type === "CERTIFICATION";
  const cls = isCert ? "bg-[#0D1B2A] text-white" : "bg-[#1A7F6E] text-white";
  return (
    <span className={`inline-flex items-center font-medium text-xs px-2.5 py-0.5 rounded ${cls}`}>
      {isCert ? "CERT" : "VERIF"}
    </span>
  );
}
